import { Action } from '@ngrx/store';
import { INomenclature } from './nomenclature';

export enum NomenclatureActionTypes {
    INITIALIZE = '[Nomenclature] Initialize',
    GET = '[Nomenclature] Get',
    CLEAR = '[Nomenclature] Clear'

}
export class ActionNomenclatureInitialize implements Action {
    readonly type = NomenclatureActionTypes.INITIALIZE;
    constructor(public payload: {nomenclature: INomenclature}) { }
}
export class ActionNomenclatureGet implements Action {
    readonly type = NomenclatureActionTypes.GET;
    constructor() { }
}

export class ActionNomenclatureClear implements Action {
    readonly type = NomenclatureActionTypes.CLEAR;
    constructor() { }
}

export type NomenclatureActions =
    ActionNomenclatureInitialize |
    ActionNomenclatureGet |
    ActionNomenclatureClear;